import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormGroup, NgForm } from '@angular/forms';
import { CountriesService } from 'src/app/countries/countries.service';
import { CoreFormService } from 'src/app/core/forms/core-forms.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-countries-detail',
  templateUrl: './countries-detail.component.html',
  styleUrls: ['./countries-detail.component.scss']
})

export class CountriesDetailComponent implements OnInit {
  @ViewChild("formDetails") public formDetails: NgForm;
  public country: any = {};

  constructor(
    private countriesService: CountriesService,
    private route: ActivatedRoute, private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private coreFormService: CoreFormService,
    private _location: Location
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.loadData(params['id']);
    });
  }

  loadData(id: number) {
    if (id != 0) {
      this.countriesService.get(id).subscribe(
        data => {
          this.country = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  cancel() {
    this.router.navigate(['/countries']);
  }

  save() {
    if (this.coreFormService.validate(this.formDetails)) {
      this.countriesService.save(this.country.id, this.country).subscribe(
        data => {
          var _msg = (this.country.id != 0 && typeof this.country.id !== "undefined") ? "modificado" : "añadido";
          this.messageService.add({ closable: false, severity: 'success', summary: "País " + _msg + " correctamente" });
          this.router.navigate(['/countries']);
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  delete() {
    this.confirmationService.confirm({
      message: '¿Está seguro de que desea eliminar este elemento?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.countriesService.delete(this.country.id).subscribe(
          res => {
            this.messageService.add({ closable: false, severity: 'success', summary: 'Elemento eliminado correctamente' });
            this._location.back();
            //this.router.navigate(['/countries']);
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
          }
        );
      },
      reject: () => {

      }
    });
  }

}
